import { useEditorStore } from '@common/stores/editorStore';
import { usePopperRelationStore } from "@common/stores/popperRelationStore";
import CurrentPinia from "@common/utils/CurrentPinia";
var piniaInstance = CurrentPinia.getInstance();
export var EditorStore = useEditorStore(piniaInstance);
export var PopperRelationStore = usePopperRelationStore(piniaInstance);
